export default __webpack_public_path__ + "static/logo-ed477501878ca74521cab7f87e99d984.png";